import { useQuery } from "@/hooks";
import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { CssBaseline, Container as MuiContainer, Paper, ThemeProvider, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { Outlet, useNavigate } from "react-router-dom";
import { configuration } from "../../configuration/configuration";
import AuthenticatedWrapper from "./components/Wrapper/Wrapper";
import lightTheme from "./theme/light";

const AdminView = () => {
    const navigate = useNavigate();
    const query = useQuery();

    const onRedirectCallback = (appState: AppState | undefined) => {
        navigate(appState?.returnTo || window.location.pathname);
    };

    const error = query.get("error");
    if (error === "access_denied") {
        return (
            <MuiContainer>
                <Helmet>Access Denied - BIM IDS</Helmet>

                <CssBaseline />

                <Paper elevation={0}>
                    <Typography variant="h4">Authentication failed...</Typography>
                    <Typography variant="subtitle1">{query.get("error_description")}</Typography>
                </Paper>
            </MuiContainer>
        );
    }

    return (
        <Auth0Provider
            domain={configuration.auth.domain}
            clientId={configuration.auth.clientId}
            authorizationParams={{
                audience: configuration.auth.audience,
                scope: configuration.auth.scope,
                redirect_uri: `${window.location.origin}/admin`,
            }}
            cacheLocation="localstorage"
            onRedirectCallback={onRedirectCallback}
        >
            <ThemeProvider theme={lightTheme}>
                <Helmet>
                    <title>Administration Panel - BIM IDS</title>
                </Helmet>

                <CssBaseline />

                <AuthenticatedWrapper>
                    <Outlet />
                </AuthenticatedWrapper>
            </ThemeProvider>
        </Auth0Provider>
    );
};

export default AdminView;
